
const pageNoteCheckbox = document.querySelector('.js-cart-page-note-checkbox');

function replaceTitle(tab) {
	if (!tab) return;
	let wrap = tab.parentNode;
	if (!tab.checked) {
		let text = wrap.querySelector('textarea').value,
			limit = Math.round(tab.nextElementSibling.offsetWidth / 12),
			title = tab.nextElementSibling;
		if (typeof text !== 'undefined' && text != '') {
			text = text.trim();
			title.innerHTML = `<span class="cutted-default-text">${title.dataset.text}</span><span class="cutted-text">${text.slice(0, limit)}</span><span class="cutted-text-dots">${text.length > limit ? '...' : ''}</span><span></span>`
		} else {
			tab.nextElementSibling.innerHTML = title.dataset.text + '<span></span>'
		}
	}
}
function moveQtyNode() {
	document.querySelectorAll('.cart-table .cart-table-prd').forEach(el => {
		const mobileContainer = el.querySelector('[data-node-mobile]'),
			desktopContainer = el.querySelector('[data-node-desktop]');
		if (window.matchMedia('(max-width:575px)').matches) {
			if(mobileContainer && !mobileContainer.innerHTML.trim().length) {
				mobileContainer.insertAdjacentHTML('afterbegin', desktopContainer.innerHTML);
				desktopContainer.innerHTML = ''
			}
		} else {
			if(desktopContainer && !desktopContainer.innerHTML.trim().length){
				desktopContainer.insertAdjacentHTML('afterbegin', mobileContainer.innerHTML);
				mobileContainer.innerHTML = ''
			}
		}
	})
}
document.querySelectorAll('[data-click="radio"] input[type="checkbox"]').forEach((el) => {
	el.addEventListener('change', function () {
		let siblings = getSiblings(this.closest('.tab-accordion-item'));
		siblings.map(el => el.querySelector('input[type="checkbox"]'));
		siblings.map(function (el) {
			let tab = el.querySelector('input[type="checkbox"]');
			tab.checked = false;
			tab.classList.contains('js-cart-page-note-checkbox') ? replaceTitle(tab) : false
		})
	})
})
document.addEventListener('DOMContentLoaded', () => {
	if (pageNoteCheckbox) {
		replaceTitle(pageNoteCheckbox);
		pageNoteCheckbox.addEventListener('click', function () {replaceTitle(this)})
	}
	moveQtyNode()
})
window.addEventListener('resize', function(){
	if (pageNoteCheckbox) replaceTitle(document.querySelector('.js-cart-page-note-checkbox'));
	moveQtyNode()
})

// ===============================
// CRE8V COINS SHOPIFY CART WIDGET
// ===============================

const CRE8V_API = "https://wallet-api-backend-production.up.railway.app";

document.addEventListener("DOMContentLoaded", async () => {
  const widget = document.getElementById("cre8v-coins-widget");
  if (!widget) return;

  const customerId = widget.dataset.customerId;
  const customerEmail = widget.dataset.customerEmail;
//   const cartTotalPaise = Number(widget.dataset.cartTotal || 0);

  const loginMsg = document.getElementById("cre8v-login-msg");
  const content = document.getElementById("cre8v-widget-content");
  const balanceEl = document.getElementById("cre8v-wallet-balance");
  const discountEl = document.getElementById("cre8v-max-discount");
  const coinInput = document.getElementById("cre8v-coin-input");
  const applyBtn = document.getElementById("cre8v-apply-coins");
  const statusEl = document.getElementById("cre8v-status");
  const cancelBtn = document.getElementById("cre8v-cancel-code");
let activeRedemptionId = null;

  if (!customerId || !customerEmail) {
    loginMsg.style.display = "block";
    return;
  }

  content.style.display = "block";

  try {
    const linkRes = await fetch(`${CRE8V_API}/shopify/link-user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        shopifyCustomerId: customerId,
        email: customerEmail,
      }),
    });

    const linkData = await linkRes.json();

    if (!linkRes.ok) {
      statusEl.textContent = linkData.error || "Wallet user not linked";
      return;
    }

    balanceEl.textContent = linkData.walletBalance || 0;

if (cancelBtn) {
  cancelBtn.addEventListener("click", async () => {
    try {
      if (!activeRedemptionId) {
        statusEl.textContent = "No active Cre8v code to cancel.";
        return;
      }

      cancelBtn.disabled = true;
      statusEl.textContent = "Cancelling Cre8v code...";

      const cancelRes = await fetch(`${CRE8V_API}/shopify/redeem/cancel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: customerEmail,
          redemptionId: activeRedemptionId,
        }),
      });

      const cancelData = await cancelRes.json();

      if (!cancelRes.ok) {
        statusEl.textContent = cancelData.error || "Failed to cancel code";
        cancelBtn.disabled = false;
        return;
      }

      activeRedemptionId = null;
      cancelBtn.style.display = "none";
      cancelBtn.disabled = false;
      applyBtn.disabled = false;

      statusEl.textContent = "Cre8v code cancelled. Coins released.";

    } catch (err) {
      console.error(err);
      statusEl.textContent = "Cancel failed";
      cancelBtn.disabled = false;
    }
  });
}

    applyBtn.addEventListener("click", async () => {
        const cartRes = await fetch("/cart.js");
const cart = await cartRes.json();

const latestCartTotalPaise = cart.total_price;

        const quoteRes = await fetch(`${CRE8V_API}/shopify/redeem/quote`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
  email: customerEmail,
  cartTotalPaise: latestCartTotalPaise,
  cartItems: cart.items.map(item => ({
    productId: item.product_id,
    variantId: item.variant_id,
    title: item.product_title,
    quantity: item.quantity,
    finalLinePrice: item.final_line_price
  }))
}),
});

const quoteData = await quoteRes.json();

    if (!quoteRes.ok) {
      statusEl.textContent = quoteData.error || "Quote failed";
      applyBtn.disabled=false;
      return;
    }

    balanceEl.textContent = quoteData.userBalance || 0;
    discountEl.textContent = `₹${quoteData.rupeeDiscount || 0}`;
    coinInput.max = quoteData.recommendedRedeem || 0;
    coinInput.value = quoteData.recommendedRedeem || 100;
      try {
        applyBtn.disabled = true;
        statusEl.textContent = "Generating discount code...";

        const coinAmount = Number(coinInput.value);

        const genRes = await fetch(`${CRE8V_API}/shopify/redeem/generate-code`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
  email: customerEmail,
  coinAmount,
  cartTotalPaise: latestCartTotalPaise,
  cartId: `shopify-cart-${customerId}`,
  cartItems: cart.items.map(item => ({
    productId: item.product_id,
    variantId: item.variant_id,
    title: item.product_title,
    quantity: item.quantity,
    finalLinePrice: item.final_line_price
  }))
}),
});

        const genData = await genRes.json();

        if (!genRes.ok) {
  // ACTIVE_REDEMPTION_EXISTS ka special handling
  if (genData.error === "ACTIVE_REDEMPTION_EXISTS") {
    const minutesLeft = genData.expiresAt
      ? Math.ceil((new Date(genData.expiresAt) - new Date()) / 60000)
      : 20;

    statusEl.innerHTML = `
      ⚠️ Active code already exists: <b>${genData.shopifyDiscountCode}</b><br>
      Expires in <b>${minutesLeft} min</b>.<br>
      Use this code at checkout, or cancel it below to generate a new one.
    `;

    // Purana redemptionId set karo taaki cancel button kaam kare
    activeRedemptionId = genData.redemptionId;

    if (cancelBtn) cancelBtn.style.display = "block";
    applyBtn.disabled = false;
    return;
  }

  // Baaki sab errors normal
  statusEl.textContent = genData.error || "Failed to generate code";
  applyBtn.disabled = false;
  return;
}

        const code = genData.shopifyDiscountCode;
        activeRedemptionId = genData.redemptionId;

if (cancelBtn) {
  cancelBtn.style.display = "block";
}

statusEl.textContent = `Discount code created: ${code}`;

// Apply latest Cre8v discount code
window.location.href = `/checkout?discount=${code}`;

      } catch (err) {
        console.error(err);
        statusEl.textContent = "Something went wrong";
        applyBtn.disabled = false;
      }
    });

  } catch (err) {
    console.error(err);
    statusEl.textContent = "Cre8v Coins widget failed";
  }
});